export enum AttestationType {
  NONE = 'NONE',
  DRIVING = 'DRIVING',
  WORK = 'WORK',
  AVAILABILITY = 'AVAILABILITY',
  REST = 'REST',
  TIMEOFF = 'TIMEOFF',
  SICKLEAVE = 'SICKLEAVE',
}
